<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">{{ title }}</h3>
    <button
      type="button"
      class="close"
      aria-label="Recover Password"
      id="recover-password-close"
      ngbAutoFocus
      i18n-aria-label
      (click)="activeModal.close(true)"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body" role="document" tabindex="0">
    <p i18n="@@recoverPasswordInstructionsNew">
      If the email address supplied corresponds to a valid account, an email containing instructions
      for resetting your password will have been sent. If you do not receive an email within 5
      minutes, please contact your support team.
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      aria-labelledby="reset-password"
      class="modal_button_okay"
      id="recover-password-ok"
      (click)="activeModal.close()"
      i18n="@@closeModal"
    >
      Close
    </button>
  </div>
</div>
